import React from 'react';

const FormTitle = ({ 
  config, 
  componentShowingState, 
  extra_title, 
  localDisabledReason,
  showLongDescriptions,
  handleToggleLongDescriptions
}) => {
  const STATE_NEW = 'new';
  const STATE_EDIT = 'edit';
  const STATE_COPY_FROM_SYSTEM = 'copy_from_system';

  const toggleDescriptionsControl = () => {
    return (
      <label className="switch-small" title={t('quote_builder.toggle_summaries')}>
        <input type="checkbox" className="pref" checked={showLongDescriptions} onChange={handleToggleLongDescriptions}/>
        <span className="slider-small"></span>
      </label>);
  }

  return (config.new_title != undefined || config.edit_title != undefined || config.title != undefined) && (
    <tr>
      <th colSpan="2">
        {config.new_title != undefined && componentShowingState == STATE_NEW && t(config.new_title) }
        {config.new_title != undefined && componentShowingState == STATE_COPY_FROM_SYSTEM && t(config.new_title) }
        {config.edit_title != undefined && componentShowingState == STATE_EDIT && t(config.edit_title)}
        {config.title != undefined && t(config.title) } {false && config.title != undefined && extra_title != undefined && ` (${t(extra_title)})` }
        {config.toggle_long_descriptions && <div className="float-right"> {toggleDescriptionsControl()} </div>}

        {localDisabledReason && (<span className="float-right"> <small className="q-read-only-message"> {localDisabledReason} <br /> </small> </span>)}
      </th>
    </tr>);
};

export default FormTitle;